import React from 'react'
import Slider from 'react-slick-dos'
import getTransitionStyle from '../utils/getTransitionStyle'
import shuffle from '../utils/shuffle'
import HomeOverlay from '../components/HomeOverlay'
import Menu from '../components/Menu'

class HomeSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentSlide: Math.floor(this.props.slides.length/2),
      showDescription: true,
      allSlides: {}
    }
  }

  componentWillMount() {
    let allSlides = this.props.slides
    if (this.props.randomizeCollection) {
      const max = this.props.slides.length - 1
      const randomizedCollection = Math.floor(Math.random() * max)
      this.setState({ currentSlide: randomizedCollection });
    } else if (this.props.shuffleSlides) {
      allSlides = shuffle(this.props.slides);
    }
    this.setState({ allSlides: allSlides });
  }

  handleSelect(index, e) {
    e.preventDefault();
    this.slider.slickGoTo(index);
  }

  renderSlide(slide, status, index) {
    const timeout = 600
    const delay = this.props.delay + 300
    const upSlideStyle = getTransitionStyle(
      status, timeout, delay + 50, 'upSlideStyle', 300
    )

    const middleSlideStyle = getTransitionStyle(
      status, timeout, delay + 300, 'upSlideStyle', 700
    )

    const downSlideStyle = getTransitionStyle(
      status, timeout, delay + 500, 'downSlideStyle', 300
    )

    const totalSlides = this.props.slides.length
    const prevSlide = (index - 1 + totalSlides) % totalSlides
    const nextSlide = (index + 1) % totalSlides

    var transitionStyle = {}

    if (prevSlide === this.state.currentSlide) {
      transitionStyle = upSlideStyle
    } else if (nextSlide === this.state.currentSlide) {
      transitionStyle = downSlideStyle
    } else {
      transitionStyle = middleSlideStyle
    }

    const className = ['slider--home__translation-container'];

    if (this.state.currentSlide === index) {
      className.push('is-active');
    }

    const slideKey = slide.collection ? slide.collection.slug : slide.link

    transitionStyle.backgroundImage = `url(${slide.image.resize.src})`

    return (
      <div
        className={className.join(' ')}
        key={slideKey}
      >
        <div
          style={transitionStyle}
          className="slider--home__slide"
        />
      </div>
    )
  }

  renderDot(slide, i) {
    const className = ['Slider__dots__item'];
    const style = {};
    const status = this.props.transition ? this.props.transition.status : "entering"

    const dotsStyle = getTransitionStyle(
      status, 300, this.props.delay + 50 * i, 'dotsAppearFromBottom'
    )

    if (this.state.currentSlide === i) {
      className.push('is-active');
      if (slide.collection) {
        dotsStyle.backgroundColor = slide.collection.color.hex;
      } else {
        dotsStyle.backgroundColor = slide.color.hex;
      }
    }

    return (
      <div
        key={slide.id}
        className={className.join(' ')}
        style={dotsStyle}
        onClick={this.handleSelect.bind(this, i)}
      >
        {
          slide.collection &&
          <div className="Slider__dots__item__name">
            {slide.collection.name}
          </div>
        }
      </div>
    );
  }

  render() {
    const { allSlides } = this.state
    const settings = {
      infinite: true,
      speed: 700,
      dots: false,
      centerMode: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            centerPadding: '0px',
          }
        },
        {
          breakpoint: 1300,
          settings: {
            centerPadding: '300px',
          }
        },
        {
          breakpoint: 3000,
          settings: {
            centerPadding: '400px',
          }
        }
      ],
      beforeChange: () => {
        this.setState({ showDescription: false })
      },
      afterChange: currentSlide => {
        this.setState({ currentSlide, showDescription: true })
      },
    }

    const status = this.props.transition ? this.props.transition.status : "entering"

    const menuStyle = {
      entering: {
        opacity: 0,
        transform: `translateY(50px)`,
      },
      entered: {
        transform: `translateY(0)`,
        opacity: 1,
        transition: `all 200ms ${this.props.delay + 1000}ms ease-in-out`,
      },
      exiting: {
        opacity: 0,
        transform: `translateY(-50px)`,
        transition: `all 200ms ease-in-out`,
      },
    }

    const opacityIn = getTransitionStyle(
      status, 300, this.props.delay, 'opacityIn'
    )

    const opacityOut = getTransitionStyle(
      status, 300, 0, 'opacityOut'
    )

    return (
      <div className="slider" style={opacityIn}>
        <Menu
          style={menuStyle[status]}
          hasWhiteLogo={true}
          data={this.props.menuData}
        />

        <HomeOverlay
          show={this.state.showDescription}
          parentStatus={status}
          slide={allSlides[this.state.currentSlide]}
          transition={this.props.transition}
          delay={this.props.delay}
        />

        <Slider
          {...settings}
          ref={el => this.slider = el}
          className="slider--home"
          initialSlide = {this.state.currentSlide}
        >
          {allSlides.map((slide, i) => this.renderSlide(slide, status, i))}
        </Slider>

        <div className="Slider__dots" style={opacityOut}>
          <div className="Slider__dots__track" style={{ marginLeft: -(7 + 150 + this.state.currentSlide * (14 + 40)) }}>
            {allSlides.map((slide, i) => this.renderDot(slide, i))}
          </div>
        </div>
      </div>
    )
  }
}

export default HomeSlider



// WEBPACK FOOTER //
// ./src/components/HomeSlider.js